import { getElement, getElements, ifSelectorExist } from "./utils";

export const loadMoreReviews = () => {
  const loadMoreButton = getElement(
    ".jpcarroll-testimonials-archive-block--load-more"
  );
  const hiddenReviews = getElements(
    ".jpcarroll-testimonials-archive-block--reviews"
  );

  if (ifSelectorExist(hiddenReviews)) {
    if (ifSelectorExist(loadMoreButton)) {
      loadMoreButton.addEventListener("click", () => {
        hiddenReviews.forEach((item) => {
          item.classList.remove("hidden");
        });

        loadMoreButton.remove();
      });
    }
  }
};
